module.exports = __webpack_public_path__ + "static/img/certificate5.9cc5c907.png";